define('views/modules/member/group-panel',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // services
    'services/viewport',
    'services/layout',
    // collections
    'collections/member/groups',
    // views
    'views/parts/panel/base-panel',
    'views/modules/member/group/group-content'
], function(
    // Libs
    _, Backbone, Mustache, U,
    // services
    Viewport,
    LayoutState,
    // collections
    CGroups,
    // views
    VBasePanel,
    VGroupContent
) {

    var VGroupPanel = VBasePanel.extend({
        header: {
            title: "Groups",
            subtitle: "Manage the groups",
        },
        tabs: [
            { id: "group", title: 'Groups', icon: 'sl-icon-layers', callback: 'showGroup', active: true },
        ],

        content: {
            group: VGroupContent
        },
        defaultView: 'group',

        initialize: function(opt) {
            opt = opt || {};
            this.url = opt.url;

        },
    });

    return VGroupPanel;
});

